import { twMerge } from 'tailwind-merge';

/** Matches TinyMCE `wrapBraces` toolbar label: `{..}` */
export function VariableInsertIcon({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={twMerge(
        'inline-flex size-5 shrink-0 items-center justify-center font-mono text-[11px] leading-none font-semibold tracking-[-0.2em]',
        className
      )}
    >
      {'{..}'}
    </span>
  );
}
